import React, { memo } from 'react';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import isEqual from 'lodash/isEqual';

import { getMessage } from "CONFIG/i18n";

import style from './style.module.less';
import sessionsInfoTableStyle from './sessionsInfoTable.module.less';

const formatTime = (second) => `${Math.floor(second / 60)}${getMessage("MINUTES")}${second % 60}${getMessage("SECONDS")}`;

const Component = ({ supportCenterSessionsInfo }) => (
  <BootstrapTable 
    data={[supportCenterSessionsInfo]}
    bordered={false}
    containerClass={style.tableArea}
    tableContainerClass={style.tableContainer}
    tableHeaderClass={`${style.tableHeader} ${sessionsInfoTableStyle.tableHeader}`}
    tableBodyClass={style.tableBody}
    trClassName={sessionsInfoTableStyle.tr}
  >
    <TableHeaderColumn width="8%" />
    <TableHeaderColumn dataAlign='center' isKey dataField="total">{getMessage("NUMBER_OF_INCOMING_CALLS")}</TableHeaderColumn>
    <TableHeaderColumn dataAlign='center' dataField="resCount">{getMessage("NUMBER_OF_RESPONSES")}</TableHeaderColumn>
    <TableHeaderColumn 
      dataAlign='center'
      dataField="resRate" 
      dataFormat={(cell) => `${cell}%`}
    >
      {getMessage("RESPONSE_RATE")}
    </TableHeaderColumn>
    <TableHeaderColumn
      dataAlign='center'
      dataField="aveReactionTime"
      dataFormat={(cell) => formatTime(cell)}
    >
      {getMessage("AVERAGE_REACTION_TIME")}
    </TableHeaderColumn>
    <TableHeaderColumn
      dataAlign='center'
      dataField="aveTalkTime"
      dataFormat={(cell) => formatTime(cell)}
    >
      {getMessage("AVERAGE_CALL_DURATION")}
    </TableHeaderColumn>
  </BootstrapTable>
);

/**
 * MEMO
 * Maybe it is because the version of react is low, but shallowEqual in react memo is not working, 
 * so use lodash/isEqual.
 */
export const SessionsInfoTable = memo(Component, isEqual);
